import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=b6bfcf86"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6bfcf86')) {
      api.createRecord('b6bfcf86', component.options)
    } else {
      api.reload('b6bfcf86', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=b6bfcf86", function () {
      api.rerender('b6bfcf86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/loader/loader.vue"
export default component.exports